import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="auto-refresh"
export default class extends Controller {
  static values = {
    interval: Number,
  };

  connect() {
    console.log("auto-refresh controller connected");
    if (!this.hasIntervalValue) {
      this.intervalValue = 5000;
    }
    this.startRefreshing();
  }

  disconnect() {
    this.stopRefreshing();
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      const frame = this.element.closest("turbo-frame");
      if (frame) {
        frame.reload();
        console.log("frame reload: ", frame);
      }
    }, this.intervalValue);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }
}
